// extracted by mini-css-extract-plugin
export default {"background":"Footer_background__wmhni","logo":"Footer_logo__+JiYo","seguinos":"Footer_seguinos__givwl","fb":"Footer_fb__KxBjW","etiquetas":"Footer_etiquetas__K9Kyy"};